export class HoaDocument {
  public title: string;
  public hoaName: string;
  public date: Date;
  public url: string;
  public imageUrl: string;

  constructor(title: string = '', hoaName: string = '', date: string = "", url: string = '', imageUrl: string = '') { 
    this.title = title;
    this.hoaName = hoaName;
    if (Date.parse(date) > 0) this.date = new Date(date);
    this.url = url;
    this.imageUrl = imageUrl;
  }

  getDate = () => this.date?.toLocaleDateString();

}
